"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function changeText(text, toInsert) {
    var s = text.split('');
    var indexIncr = 0;
    toInsert.forEach(function (data) {
        data.toAdd = data.toAdd || '';
        data.toRemove = data.toRemove || '';
        s.splice.apply(s, [data.pos + indexIncr, data.toRemove.length].concat(data.toAdd.split('')));
        indexIncr += data.toAdd.length - data.toRemove.length;
    });
    return s.join('');
}
exports.changeText = changeText;
//# sourceMappingURL=change.js.map